/* global axios */

import ApiClient from './ApiClient';

class EasyOrdersAPI extends ApiClient {
  constructor() {
    super('easy_orders', { accountScoped: true });
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  installUrl() {
    return axios.get(`${this.url}/install_url`);
  }

  connect(payload) {
    return axios.post(`${this.url}/connect`, payload);
  }

  products(params = {}) {
    return axios.get(`${this.url}/products`, { params });
  }

  categories(params = {}) {
    return axios.get(`${this.url}/categories`, { params });
  }

  order(orderId) {
    return axios.get(`${this.url}/order`, { params: { order_id: orderId } });
  }

  updateOrderStatus(payload) {
    return axios.patch(`${this.url}/order_status`, payload);
  }

  addOrderNote(payload) {
    return axios.post(`${this.url}/order_note`, payload);
  }

  updateProductStock(payload) {
    return axios.patch(`${this.url}/product_stock`, payload);
  }

  createConversation(payload) {
    return axios.post(`${this.url}/create_conversation`, payload);
  }

  updateSettings(payload) {
    return axios.patch(`${this.url}/settings`, payload);
  }

  disconnect() {
    return axios.delete(`${this.url}/disconnect`);
  }
}

export default new EasyOrdersAPI();
